import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';

import UserListHdr from './user-list-hdr';
import UserListItem from './user-list-item';

const UserList = (props) => {
  if (!props.list.length) {
    return (
      <Typography align='center'>No Users</Typography>
    );
  } else {
    return (
      <Paper>
        <Table>
          <UserListHdr />
          <TableBody>
            {
              props.list.map((item, idx) => {
                return (
                  <UserListItem key={idx} {...item} idx={idx} />
                );
              })
            }
          </TableBody>
        </Table>
      </Paper>
    );
  }
};

UserList.propTypes = {
  list: PropTypes.array.isRequired
};

export default React.memo(UserList);